import { ReactNode } from 'react';

import { NavBar, Wrapper } from '../Common/Layout';

interface ClaimLayoutProps {
  children?: ReactNode;
}

export const ClaimLayout = ({ children }: ClaimLayoutProps) => (
  <Wrapper>
    <NavBar />

    {children}
  </Wrapper>
);

export default undefined;
